import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import { useSvgId } from '../../primitives/useSvgId.js';
import type { IconProps } from '../../primitives/types.js';

/** Star — a diagonal gleam sweeps across the five-point body, clipped to
 *  its silhouette so the highlight feels like light catching the surface. */
export function IcnStar(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  const clipId = useSvgId('star-clip');
  const starPath = 'M8 2l1.8 3.9 4.2.5-3.1 2.9.8 4.2L8 11.4l-3.7 2.1.8-4.2L2 6.4l4.2-.5L8 2z';
  return (
    <Svg {...props} iconName="star">
      <defs>
        <clipPath id={clipId}>
          <path d={starPath} />
        </clipPath>
      </defs>
      <path d={starPath} />
      {animate && (
        <g clipPath={`url(#${clipId})`}>
          <line x1="-2" y1="10" x2="4" y2="4" stroke="currentColor" strokeWidth="2.2" opacity="0.7">
            <animate
              attributeName="x1"
              values="-4;18;18"
              keyTimes="0;0.5;1"
              dur="3s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="x2"
              values="2;24;24"
              keyTimes="0;0.5;1"
              dur="3s"
              repeatCount="indefinite"
            />
            <animate
              attributeName="opacity"
              values="0;0.9;0"
              keyTimes="0;0.5;1"
              dur="3s"
              repeatCount="indefinite"
            />
          </line>
        </g>
      )}
    </Svg>
  );
}
